<script>
  export let size = "w-10 h-10";
</script>

<svg
  class="{size} logo-shine-effect"
  viewBox="-20 10 258 258"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M197.549 58.9141C175.821 59.0587 154.963 60.2734 134.744 62.298L144.346 2.86329L133.526 0L110.289 65.1902C98.6855 66.7809 87.3429 68.6897 76.2034 70.8589L36.6929 36.9623L28.2513 42.6599L52.909 75.8913C34.8073 80.1718 17.2278 85.1174 0.228433 90.844C-1.71518 166.562 8.90215 217.117 26.0466 254.6C93.899 263.624 159.344 254.716 222.294 227.5C221.191 137.958 212.227 85.1464 197.549 58.9141ZM195.547 195.975C159.46 215.989 118.934 223.885 74.3758 220.848C64.5707 195.339 59.4651 160.604 60.0453 114.878C98.0763 100.301 138.515 94.0832 181.884 98.0166C192.443 130.438 196.91 163.091 195.547 195.975Z"
    class="fill-brand"
  />
  <path
    d="M156.907 111.147C151.743 111.986 147.769 118.031 145.854 126.649C145.796 126.649 145.767 126.649 145.738 126.649C143.185 135.037 138.486 140.908 132.568 141.862C127.404 142.672 122.299 139.606 118.209 133.967C117.715 133.186 109.912 119.911 98.9755 122.224C86.7917 124.827 78.6691 142.412 81.0189 162.918C83.3686 183.452 95.1463 197.971 107.446 196.525C123.604 194.645 121.197 164.248 137.558 161.211C142.924 160.228 148.233 163.67 152.439 169.627C155.92 175.036 160.214 178.044 164.478 177.35C173.123 175.961 178.461 160.025 176.372 141.747C174.254 123.468 165.552 109.759 156.907 111.147Z"
    class="fill-brand"
  />
</svg>

<style>
  @keyframes logo-shine {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.05);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .logo-shine-effect {
    animation: logo-shine 2s ease-in-out infinite;
  }
</style>
